import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ToggleService } from 'src/app/services/toggle.service';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
})
export class HeaderMenuComponent implements OnInit {

  constructor(
    public router: Router,
    public authService: AuthenticationService,
    public toggleService: ToggleService
  ) {    
  }

  ngOnInit() {
    this.toggleService.onResize(null);
  }

  goToHome(){
    if(!this.authService.isLoggedIn){
      this.router.navigateByUrl('/login');
    }else{
      this.router.navigateByUrl('/home');
    }
  }

}
